export const SET_SERVER_APP_SETTINGS = 'SET_SERVER_APP_SETTINGS';
export const SET_IS_SHOW_USER_SETTINGS = 'SET_IS_SHOW_USER_SETTINGS';
export const SET_IS_SHOW_CHANGE_PASSWORD = 'SET_IS_SHOW_CHANGE_PASSWORD';
export const SET_IS_SHOW_SIGN_OUT_DIALOG = 'SET_IS_SHOW_SIGN_OUT_DIALOG';
export const SET_IS_SHOW_CREDENTIALS = 'SET_IS_SHOW_CREDENTIALS';
